import $ from "jquery";

const initPaymentButtonLayout = function() {
  let applePay, amazonPay, paypalExpress;
  applePay = amazonPay = paypalExpress = false;
  const body = document.querySelector('body');

  // Check if apple pay available
  if( window.PaymentRequest ) {
    body.classList.add( 'is-apple-pay-available' );
    applePay = true;
  }

  // Check if paypal express is available
  if( document.getElementById( 'startPayPalExpress' ) ) {
    paypalExpress = true;
  }

  // Check if amazon pay is available
  if( document.getElementById( 'payWithAmazonDiv' ) ) {
    amazonPay = true;

    document.getElementById( 'payWithAmazonButtonMobile' )?.addEventListener( 'click', e => {
      e.preventDefault();
      document.querySelector( '#payWithAmazonDiv > a' ).dispatchEvent( new Event( 'click' ) );
    });
  }

  let colCount = 1;
  if ( paypalExpress && amazonPay && applePay ) {
    colCount = 3;
  } else if ( paypalExpress && amazonPay || amazonPay && applePay || paypalExpress && applePay ) {
    colCount = 2;
  }

  document.querySelectorAll( '.en_mdl_checkout_process_footer__paymentbutton-container' ).forEach( ( paymentButtonContainer ) => {
    paymentButtonContainer.dataset.enGriditemDefault = colCount + '-1';
  } );
}

$( document ).ready( function() {
  initPaymentButtonLayout();
} );
